module.exports = __webpack_public_path__ + "static/media/goal.4d6ee55d.png";